import { render, staticRenderFns } from "./closed-order-list.vue?vue&type=template&id=376efb16&"
import script from "./closed-order-list.vue?vue&type=script&lang=js&"
export * from "./closed-order-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports